import { i18n } from '@/shared/i18n';
import type { JobDeliveryState, JobNode } from '@/entities/media-campaign';

// Getters, not values: a resolved label here would freeze English at import.
export const DELIVERY_LABELS: Record<JobDeliveryState, string> = {
  get active() {
    return i18n.t('projects:deliveryJobReview.publishReportDialog.delivery.serving');
  },
  get paused() {
    return i18n.t('projects:deliveryJobReview.publishReportDialog.delivery.livePaused');
  },
  get draft() {
    return i18n.t('projects:deliveryJobReview.publishReportDialog.delivery.draft');
  },
  get in_review() {
    return i18n.t('projects:deliveryJobReview.publishReportDialog.delivery.inReview');
  },
  get rejected() {
    return i18n.t('projects:deliveryJobReview.publishReportDialog.delivery.refused');
  },
  get ended() {
    return i18n.t('projects:deliveryJobReview.publishReportDialog.delivery.ended');
  },
  get unknown() {
    return i18n.t('projects:deliveryJobReview.publishReportDialog.delivery.notReported');
  },
};

/** The platform's word for a row's status, once it has given one. */
export function platformStatusLabel(node: JobNode, fieldKey: string): string | undefined {
  return fieldKey === 'status' && node.deliveryState
    ? DELIVERY_LABELS[node.deliveryState]
    : undefined;
}
